import React from 'react';
import { Echarts } from '@tencent/spaui';
import {
  rightChartStyle,
  barChartLegendStyle,
  titleMargin,
  gridStyle,
} from './index';
import { SwitchEmployeeGroup } from './switchEmployeeGroup';

const BarChartInternal = (props) => {
  const seriesData = props.yAxisData.map((item) => {
    return {
      name: item.name,
      data: item.data,
      type: 'bar',
      barWidth: '20%',
      color: item.color,
      label: {
        show: false,
        distance: 0,
        offset: [0, 0],
      },
      stack: 'total',
    };
  });
  const option = {
    title: {
      text: props.title,
      textAlign: 'left',
      textStyle: {
        fontSize: 12,
      },
      padding: titleMargin,
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    xAxis: {
      type: 'category',
      data: props.xAxisData,
      nameTextStyle: {
        color: '#939599',
        width: 70,
        overflow: 'truncate',
        fontSize: 10,
      },
    },
    yAxis: {
      type: 'value',
      name: '(条)',
    },
    grid: gridStyle,
    dataZoom: {
      startValue: 0,
      endValue: 5,
      type: 'slider',
      height: 10,
      bottom: "35",
    },
    legend: barChartLegendStyle,
    series: seriesData,
  };

  return (
    <div className="whole-chart display-flex">
      <Echarts {...option} style={rightChartStyle} size="small" />
      {!props.hideSwitcher && <SwitchEmployeeGroup target={props.hideSwitcher ? 'USER' : props.target} setTarget={props.setTarget} />}
    </div>
  );
};
export const BarChart = React.memo(BarChartInternal);
